import { setShowEstimateModal } from '../State/showEstimateModal';

export default () => async (dispatch) => {
  dispatch(setShowEstimateModal(true));
}